export default __webpack_public_path__ + "static/media/icone-barcode.549b0aff.svg";